import type { MessageKey } from './en.ts';

/** US wording, used instead of `en` when a US plan is open. Account names (401(k), Roth IRA) stay as they are. */
export const enUS: Partial<Record<MessageKey, string>> = {
  'waypoint.cashHint': 'Checking and savings',
  'waypoint.investmentsHint': '401(k)s, IRAs, brokerage accounts and funds',
  'waypoint.estimate.hint.investments': 'Check your 401(k) or brokerage app when you can.',
  'plan.freq.fortnightly': 'Every two weeks',
  'move.per.fortnightly': 'every two weeks',
  'plan.field.payoffChart': '{name} balance falling from {from} today to $0 in {date}',
  'whatIf.claudeHint': 'Asking Claude “what if I invest $300 more?” works too',
  'whatIf.kind.raise': 'Pay raise',
  'whatIf.kind.raiseFrom': 'Pay raise from {date}',
  'plan.field.taxRelief': 'Tax savings (%)',
  'plan.tax.none': 'No tax advantage',
  'plan.tax.brokerage': 'Brokerage account',
  'plan.summaryText.taxRelief': '{name} tax advantage: {account}',
  'plan.summaryText.taxReliefPct': '{name} tax advantage: {account}, {pct}%',
  'plan.summaryText.taxReliefCleared': '{name} tax advantage removed',
  'smap.own.talk.3': 'We put 500 a month into the 401(k)',
};
